import React from 'react'
import { Outlet } from 'react-router-dom'

const Shipments = () => {
  return (
    <Outlet />
  )
}

export default Shipments